import React, { useContext } from 'react';

import { HeaderStyledNav, HeaderStyledNavWrapper } from './AudiHeaderNavStyles';
import AudiHeaderActiveBar from '../AudiHeaderActiveBar/AudiHeaderActiveBar';
import AudiHeaderNavItem from '../AudiHeaderNavItem/AudiHeaderNavItem';
import type { AudiHeaderNavProps } from '../../interfaces/header-components.interfaces';
import AudiHeaderDealerContext from '../AudiHeaderDealerContext/AudiHeaderDealerContext';
import { DealerContext } from '../../context';
import { queryStringExists } from '../../utils/append-partner-id';

const AudiHeaderNav: React.FC<AudiHeaderNavProps> = ({
  headerNavigationItemsAmount,
  navigation,
  headerDispatch,
  headerState,
  navigationElement,
  isClosing,
  isOpen,
  useFootnoteReferenceServiceTextParserHook,
  useOneLayer,
  windowWidth,
  onClickDealerContext,
  showDealerAdditionalData,
}) => {
  const { dealerData, renderDealerContext } = useContext(DealerContext);
  const hasPartnerId = queryStringExists('partner_id');
  const isSubNavOpen = headerState.activeItem.index !== -1;

  return (
    <HeaderStyledNavWrapper
      headerNavigationItemsAmount={headerNavigationItemsAmount}
      isOpen={isOpen}
      isSubNavOpen={isSubNavOpen}
      ref={navigationElement}
      showSearch={headerState.activeItem.showSearch}
    >
      <HeaderStyledNav
        aria-label="Main"
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        isOpen={isOpen}
        isSubNavOpen={isSubNavOpen}
        role="navigation"
      >
        {navigation?.map((navigationItem, index) => {
          const link = navigationItem?.Link;
          const key = link ? `${link?.Text}${link?.Url}` : `link-${index}`;

          return (
            <AudiHeaderNavItem
              headerDispatch={headerDispatch}
              headerNavigationItemsAmount={headerNavigationItemsAmount}
              headerState={headerState}
              index={index}
              isClosing={isClosing}
              isSubNavOpen={isSubNavOpen}
              item={navigationItem}
              key={key}
              useFootnoteReferenceServiceTextParserHook={useFootnoteReferenceServiceTextParserHook}
              useOneLayer={useOneLayer}
            />
          );
        })}
      </HeaderStyledNav>
      {!!dealerData && renderDealerContext && hasPartnerId && (
        <AudiHeaderDealerContext
          isMobileView
          headerNavigationItemsAmount={headerNavigationItemsAmount}
          onClickDealerContext={onClickDealerContext}
          showDealerAdditionalData={showDealerAdditionalData}
        />
      )}
      <AudiHeaderActiveBar
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        headerState={headerState}
        windowWidth={windowWidth}
      />
    </HeaderStyledNavWrapper>
  );
};

export default AudiHeaderNav;
